import React, { Fragment } from 'react';
import { SingleInfoCard } from '../..';
export const InfoCardList = ({ items }) => {
    return (React.createElement(Fragment, null, items.map((item, index) => (React.createElement(SingleInfoCard, Object.assign({}, item, { key: index }))))));
};
//# sourceMappingURL=InfoCardList.js.map